import React, { useRef, useState } from "react";
import axios from "axios";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import InputGroup from "react-bootstrap/InputGroup";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import alertify from "alertifyjs";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { API_URL } from "../constants.js";
import { normalizeUkPhone } from "../Common/normalizeUkPhone";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";

export function SendTestMessage() {
  const { t } = useTranslation();
  const testMessagePhone = useRef();
  const [sending, setSending] = useState(false);

  const sendTestMessage = (e) => {
    e.preventDefault();
    const phone = normalizeUkPhone(testMessagePhone.current?.value?.trim());

    if (!phone) {
      alertify.error(t("Please enter a phone number"));
      return;
    }

    setSending(true);
    axios
      .post(API_URL + "dashboard/send-test-message", { phone_no: phone })
      .then((response) => {
        setSending(false);
        if (response.data.status) {
          alertify.success(response.data.message);
          if (testMessagePhone.current) {
            testMessagePhone.current.value = "";
          }
        } else {
          alertify.error(response.data.message);
        }
      })
      .catch((error) => {
        setSending(false);
        const message =
          error.response?.data?.message ||
          error.response?.data?.errors?.phone_no?.[0] ||
          t("Failed to send SMS");
        alertify.error(message);
      });
  };

  return (
    <Row>
      <Col md={12}>
        <Card>
          <CardHeader title={t("Send Test Message")}>
            <CardHeaderToolbar>
              <Button
                as={Link}
                to="/patients-without-sample-received"
                variant="primary"
              >
                {t("Receive Samples")}
              </Button>
            </CardHeaderToolbar>
          </CardHeader>
          <CardBody>
            <p className="text-muted mb-5">
              Send an SMS to a UK mobile number. Enter the number without the
              country code (+44 is added automatically).
            </p>
            <Form onSubmit={sendTestMessage}>
              <Form.Row>
                <Form.Group as={Col} md={6}>
                  <Form.Label>{t("Mobile Number")}</Form.Label>
                  <InputGroup>
                    <InputGroup.Prepend>
                      <InputGroup.Text>+44</InputGroup.Text>
                    </InputGroup.Prepend>
                    <Form.Control
                      ref={testMessagePhone}
                      type="tel"
                      placeholder="7123456789"
                      disabled={sending}
                    />
                  </InputGroup>
                </Form.Group>
              </Form.Row>
              <Button variant="primary" type="submit" disabled={sending}>
                {t("Send")}
                <span
                  dangerouslySetInnerHTML={{
                    __html: sending
                      ? `<i class='fas fa-spinner fa-spin'></i>`
                      : ``,
                  }}
                />
              </Button>
            </Form>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
}
